import { createReducer } from '@reduxjs/toolkit';
import {
  addEmployeeFunctionLinkErrorAction,
  addEmployeeFunctionLinkSuccessAction,
  clearEmployeeFunctionLinkErrorsAction,
  deleteEmployeeFunctionLinkErrorAction,
  deleteEmployeeFunctionLinkSuccessAction,
  setEmployeeFunctionLinksAction,
  setEmployeeFunctionLinksErrorAction,
  setEmployeeFunctionLinksLoadingAction,
  setLinkCountsByFunctionAction,
  setSelectableFunctionsAction,
  updateEmployeeFunctionLinkErrorAction,
  updateEmployeeFunctionLinkSuccessAction,
} from 'store/actions/employee-function-link-actions';
import IEmployeeFunctionLinksState from 'types/company/payroll/IEmployeeFunctionLinksState';

const initialState: IEmployeeFunctionLinksState = {
  links: [],
  selectableFunctions: { perEmployee: [], commonFunctionIds: [] },
  linkCountsByFunction: {},
  loading: false,
  getError: false,
  addError: '',
  addSuccess: false,
  updateError: '',
  updateSuccess: false,
  deleteError: '',
  deleteSuccess: false,
};

const employeeFunctionLinkReducer = createReducer(initialState, builder => {
  return builder
    .addCase(setEmployeeFunctionLinksAction, (state, action) => ({ ...state, links: action.payload }))
    .addCase(setEmployeeFunctionLinksLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setEmployeeFunctionLinksErrorAction, (state, action) => ({ ...state, getError: action.payload }))
    .addCase(setLinkCountsByFunctionAction, (state, action) => ({ ...state, linkCountsByFunction: action.payload }))
    .addCase(setSelectableFunctionsAction, (state, action) => ({ ...state, selectableFunctions: action.payload }))
    .addCase(addEmployeeFunctionLinkSuccessAction, (state, action) => ({ ...state, addSuccess: action.payload }))
    .addCase(addEmployeeFunctionLinkErrorAction, (state, action) => ({ ...state, addError: action.payload }))
    .addCase(updateEmployeeFunctionLinkSuccessAction, (state, action) => ({ ...state, updateSuccess: action.payload }))
    .addCase(updateEmployeeFunctionLinkErrorAction, (state, action) => ({ ...state, updateError: action.payload }))
    .addCase(deleteEmployeeFunctionLinkSuccessAction, (state, action) => ({ ...state, deleteSuccess: action.payload }))
    .addCase(deleteEmployeeFunctionLinkErrorAction, (state, action) => ({ ...state, deleteError: action.payload }))
    .addCase(clearEmployeeFunctionLinkErrorsAction, state => ({
      ...state,
      addError: '',
      addSuccess: false,
      updateError: '',
      updateSuccess: false,
      deleteError: '',
      deleteSuccess: false,
    }));
});

export default employeeFunctionLinkReducer;
